export enum FacilityTypeEnum {
  KNS,
  VNS,
}

export const FacilityType: Record<FacilityTypeEnum, string> = {
  [FacilityTypeEnum.KNS]: "KNS",
  [FacilityTypeEnum.VNS]: "VNS",
};
